import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import commingSoon from "../../../assets/img/coming soon.jpg";

import { SERVER_PATH } from "../../../config/env";
import { FadeLoader } from "react-spinners";
import apiClient from "../../../utils/api";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#000",
};

const Yoga = () => {
  const [yogaProduct, setYogaProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchData = () => {
    apiClient
      // .post(`get/all_products.php`, {
      //   category: "yoga",
      // })
      .post(`get/active_products.php`, {
        category: "wooden",
      })
      .then((res) => {
        const woodenCategory = res.data.filter(
          (item) => item.category?.toLowerCase() === "wooden"
        );
        setYogaProduct(woodenCategory);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <>
        <FadeLoader color="#000" size={250} cssOverride={override} />
        <h2 className="text-center mt-3">Loading...</h2>
      </>
    );
  }
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = yogaProduct.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(yogaProduct.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Optional: scroll to top on page change
  };

  return (
    <>
      {currentItems.length >= 1 ? (
        <>
          {currentItems.map((data, index) => {
            return (
              <>
                <div
                  className="col-md-4 col-lg-4 col-xl-3 d-none d-sm-block"
                  key={"product" + index}
                >
                  <div
                    className="card mb-4 product-wap rounded-1"
                    style={{ height: "350px" }}
                  >
                    <div className="card rounded-0">
                      <img
                        className="card-img rounded-0 img-fluid"
                        style={{ height: "180px", objectFit: "contain" }}
                        src={data.img1}
                        alt={data.product_name}
                      />
                      <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              className="btn btn-success text-white mt-2"
                              to={`/product/${data.product_id}`}
                            >
                              <AiOutlineEye
                                style={{ fontSize: "1.3em", marginTop: "-3px" }}
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link to="/" className="h3 text-decoration-none">
                        {data.product_name}{" "}
                        {/* <small className="productWeight ms-1">
                          {data.weight}Gms.
                        </small> */}
                      </Link>
                      <span className="d-block text-secondary my-2">
                        RS.{data.offer_price}
                      </span>
                      <Link to={`/product/${data.product_id}`}>
                        <button className="btn btn-sm w-100 btn-outline-success text-uppercase">
                          Buy Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="d-block d-sm-none"
                  key={"product-mobile" + index}
                >
                  <Link
                    to={`/product/${data.product_id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        background: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        padding: "5px",
                        margin: "10px 0",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={data.img1}
                        alt={data.product_name}
                        style={{
                          width: "170px",
                          height: "200px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          backgroundColor: "#f8f8f8",
                        }}
                      />
                      <div style={{ flex: 1, paddingLeft: "20px" }}>
                        <h5
                          style={{
                            fontSize: "17px",
                            fontWeight: "600",
                            marginBottom: "6px",
                            fontFamily: "poppins",
                            color:"black"
                          }}
                        >
                          {data.product_name}
                        </h5>

                        {/* <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            marginBottom: "6px",
                            fontFamily: "poppins",
                            color:"black"
                          }}
                        >
                          {data.weight}Gms.
                        </p> */}
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#444",
                            marginBottom: "6px",
                            fontFamily: "poppins",
                          }}
                          title={data.description}
                        >
                          {data.description.length > 40
                            ? data.description.slice(0, 50) + "..."
                            : data.description}
                        </p>
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#000",
                            marginBottom: "10px",
                            fontFamily: "poppins",
                          }}
                        >
                          <del
                            style={{ fontSize: "15px", fontWeight: "lighter" }}
                          >
                            ₹{data.price}
                          </del>{" "}
                          ₹{data.offer_price}
                        </div>
                        <Link to={`/product/${data.product_id}`}>
                          <button
                            style={{
                              backgroundColor: "#198754",
                              color: "white",
                              padding: "5px 5px",
                              border: "none",
                              borderRadius: "6px",
                              fontWeight: "400",
                              width: "60%",
                              fontFamily: "poppins",
                            }}
                          >
                            Buy Now
                          </button>
                        </Link>
                      </div>
                    </div>
                  </Link>
                </div>
              </>
            );
          })}
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination" style={{ gap: "8px" }}>
                {[...Array(totalPages).keys()].map((num) => (
                  <li
                    key={num + 1}
                    className={`page-item ${
                      currentPage === num + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        color: currentPage === num + 1 ? "#fff" : "#343a40",
                        backgroundColor:
                          currentPage === num + 1 ? "#007bff" : "#fff",
                        transition:
                          "background-color 0.2s ease, color 0.2s ease",
                        padding: "6px 12px",
                        minWidth: "40px",
                      }}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </>
      ) : (
        <>
          <div className="col-md-3">
            <div className="card mb-4 product-wap rounded-1">
              <div className="card rounded-0">
                <img
                  className="card-img rounded-0 img-fluid"
                  style={{ height: "180px", objectFit: "cover" }}
                  src={commingSoon}
                  alt="coming soon..."
                />
                <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                  <ul className="list-unstyled">
                    <li>
                      <AiOutlineEye
                        style={{ fontSize: "1.3em", marginTop: "-3px" }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card-body">
                <Link to="/" className="h3 text-decoration-none">
                  Coming soon...
                </Link>
              </div>
            </div>
          </div>
          {/* <FadeLoader color="#000" size={250} cssOverride={override} />
          <h2 className="text-center mt-3">Loading...</h2> */}
        </>
      )}
    </>
  );
};
export default Yoga;
